<template>
  <div class="post-content">
    <div class="timestamp-container">
      {{ -(new Date().getTime() - new Date(createdAt * 1000).getTime()) | duration("humanize", true) }}
    </div>
    <post-caption :copy="body" />

    <post-link v-if="link" :link="link" />

    <div v-if="promoCode" class="promo-code-wrapper">
      <h4>PROMO CODE</h4>

      <div class="promo-code flex align-center justify-between">
        {{ promoCode }}
        <div class="copy-promo-code-icon" :class="{ copied: copied }" @click="copyToClipboard" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.timestamp-container {
  color: $secondaryGrey4;
  font-family: NHaasGroteskDSPro-55Rg;
  margin-top: 24px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-weight: 600;
}

.promo-code-wrapper {
  background: $secondaryGrey;
  padding: 24px;
  margin-top: 24px;
  border-radius: 4px;

  h4 {
    color: $secondaryGrey4;
    font-size: 12px;
  }

  .promo-code {
    font-family: NHaasGroteskDSPro-65Md;
    font-size: 16px;
  }
}

.copy-promo-code-icon {
  background: url("~@/assets/img/icons/copy_icon_button.svg") no-repeat center;
  width: 40px;
  height: 40px;

  &.copied {
    background: url("~@/assets/img/icons/copied_checkmark.svg") no-repeat center;
  }

  @media (hover: hover) and (pointer: fine) {
    &:not(.copied) {
      &:hover {
        cursor: pointer;
        background: url("~@/assets/img/icons/copy_icon_button_green.svg") no-repeat center;
      }
    }
  }
}
</style>

<script>
import PostCaption from "./PostCaption";
import PostLink from "./PostLink";
import InlineSvg from "vue-inline-svg";

export default {
  components: { PostCaption, PostLink, InlineSvg },
  data: function () {
    return {
      copied: false,
    };
  },
  props: {
    createdAt: {
      type: Number,
    },
    body: {
      type: String,
    },
    promoCode: {
      type: String,
    },
    link: {
      type: Object,
    },
  },
  methods: {
    copyToClipboard: function () {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);

      this.$utils.copyToClipboard(this.promoCode);
      this.$notify.$emit("fire", {
        type: "success-top-center",
        fadeTime: 2000,
        message: `Promo code copied`,
      });
    },
  },
};
</script>
